import {TextField, Typography, Checkbox, FormControlLabel, Stack, Divider} from "@mui/material";
import {useEffect, useState} from "react";
import {alert} from "src/services/alert";
import {asyncRequest} from "src/services/network";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import UserInfo from "src/components/common/UserInfo";

const DEFAULT_ITEMS = {
  xfqV2: true,
  xfqV2Bak: true,
  dhqV2: true,
  activityOrders: true,
  contribution: true,
  pintuanContribution: false,
};

const UserLiquidateDialog = ({user, open, onClose, onFinish}) => {
  const [password, setPassword] = useState("");
  const [items, setItems] = useState({...DEFAULT_ITEMS});

  useEffect(() => {
    if (open) {
      setPassword("");
      setItems({...DEFAULT_ITEMS});
    }
  }, [open]);

  function toggleItem(key) {
    setItems((prev) => ({...prev, [key]: !prev[key]}));
  }

  const hasSelected = Object.values(items).some(Boolean);

  async function handleConfirm() {
    if (!password) return alert("请输入管理员操作密码", "warning");
    if (!hasSelected) return alert("请至少选择一项清算内容", "warning");

    await asyncRequest({
      path: "/user/liquidate",
      data: {
        uid: user.uid,
        password,
        liquidateXfqV2: items.xfqV2,
        liquidateXfqV2Bak: items.xfqV2Bak,
        liquidateDhqV2: items.dhqV2,
        liquidateActivityOrders: items.activityOrders,
        liquidateContribution: items.contribution,
        liquidatePintuanContribution: items.pintuanContribution,
      },
    });

    alert("资产清算成功", "success");
    onFinish();
  }

  const LIQUIDATE_OPTIONS = [
    {key: "xfqV2",             label: "权益金清零",          value: Math.trunc(user.xfqV2 || 0),                     unit: ""},
    {key: "xfqV2Bak",          label: "消费券清零",       value: Math.trunc(user.xfqV2Bak || 0),                  unit: ""},
    {key: "dhqV2",             label: "兑换券清零",           value: Math.trunc(user.dhqV2 || 0),                     unit: ""},
    {key: "activityOrders",    label: "活动订单剩余积分清零",  value: null,                                            unit: ""},
    {key: "contribution",      label: "系统贡献值转至公司",    value: Math.trunc(user.contributionValue || 0),         unit: ""},
    {key: "pintuanContribution", label: "拼团贡献值转至公司",  value: Math.trunc(user.pintuanContributionValue || 0),  unit: ""},
  ];

  return (
    <FormDialog title="用户资产清算" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户" required>
        <UserInfo {...user} enablePreview={false}/>
      </FormItem>

      <FormItem title="清算内容">
        <Stack direction="column" spacing={0} divider={<Divider flexItem/>}>
          {LIQUIDATE_OPTIONS.map(({key, label, value}) => (
            <FormControlLabel
              key={key}
              sx={{mx: 0, py: 0.5}}
              control={
                <Checkbox
                  checked={items[key]}
                  onChange={() => toggleItem(key)}
                  size="small"
                />
              }
              label={
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Typography variant="body2">{label}</Typography>
                  {value !== null && (
                    <Typography variant="body2" color={value > 0 ? "error.main" : "text.disabled"}>
                      （当前：{value}）
                    </Typography>
                  )}
                </Stack>
              }
            />
          ))}
        </Stack>
        {!hasSelected && (
          <Typography variant="caption" color="error" sx={{mt: 0.5, display: "block"}}>
            请至少选择一项清算内容
          </Typography>
        )}
      </FormItem>

      <FormItem title="操作密码" required>
        <TextField
          fullWidth
          type="password"
          placeholder="请输入管理员操作密码"
          autoComplete="off"
          value={password}
          size="small"
          onChange={(e) => setPassword(e.target.value)}
        />
      </FormItem>
    </FormDialog>
  );
};

export default UserLiquidateDialog;
